/*
 * jQuery Easing v1.4.1 - http://gsgd.co.uk/sandbox/jquery/easing/
 * Open source under the BSD License.
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * https://raw.github.com/gdsmith/jquery-easing/master/LICENSE
*/

import $ from "jquery";

var pow = Math.pow,
  sqrt = Math.sqrt,
  sin = Math.sin,
  cos = Math.cos,
  PI = Math.PI,
  c1 = 1.70158,
  c2 = c1 * 1.525,
  c3 = c1 + 1,
  c4 = ( 2 * PI ) / 3,
  c5 = ( 2 * PI ) / 4.5;

// x is the fraction of animation progress, in the range 0..1
function bounceOut(x) {
  var n1 = 7.5625,
    d1 = 2.75;
  if ( x < 1/d1 ) {
    return n1*x*x;
  } else if ( x < 2/d1 ) {
    return n1*(x-=(1.5/d1))*x + 0.75;
  } else if ( x < 2.5/d1 ) {
    return n1*(x-=(2.25/d1))*x + 0.9375;
  } else {
    return n1*(x-=(2.625/d1))*x + 0.984375;
  }
}
$.extend( $.easing,
  {
    def: 'easeOutQuad',
    swing: function (x) {
      return $.easing[$.easing.def](x);
    },
    easeInQuad: function (x) {
      return x * x;
    },
    easeOutQuad: function (x) {
      return 1 - ( 1 - x ) * ( 1 - x );
    },
    easeInOutQuad: function (x) {
      return x < 0.5 ?
        2 * x * x :
        1 - pow( -2 * x + 2, 2 ) / 2;
    },
    easeInCubic: function (x) {
      return x * x * x;
    },
    easeOutCubic: function (x) {
      return 1 - pow( 1 - x, 3 );
    },
    easeInOutCubic: function (x) {
      return x < 0.5 ?
        4 * x * x * x :
        1 - pow( -2 * x + 2, 3 ) / 2;
    },
    easeInQuart: function (x) {
      return x * x * x * x;
    },
    easeOutQuart: function (x) {
      return 1 - pow( 1 - x, 4 );
    },
    easeInOutQuart: function (x) {
      return x < 0.5 ?
        8 * x * x * x * x :
        1 - pow( -2 * x + 2, 4 ) / 2;
    },
    easeInQuint: function (x) {
      return x * x * x * x * x;
    },
    easeOutQuint: function (x) {
      return 1 - pow( 1 - x, 5 );
    },
    easeInOutQuint: function (x) {
      return x < 0.5 ?
        16 * x * x * x * x * x :
        1 - pow( -2 * x + 2, 5 ) / 2;
    },
    easeInSine: function (x) {
      return 1 - cos( x * PI/2 );
    },
    easeOutSine: function (x) {
      return sin( x * PI/2 );
    },
    easeInOutSine: function (x) {
      return -( cos( PI * x ) - 1 ) / 2;
    },
    easeInExpo: function (x) {
      return x === 0 ? 0 : pow( 2, 10 * x - 10 );
    },
    easeOutExpo: function (x) {
      return x === 1 ? 1 : 1 - pow( 2, -10 * x );
    },
    easeInOutExpo: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        pow( 2, 20 * x - 10 ) / 2 :
        ( 2 - pow( 2, -20 * x + 10 ) ) / 2;
    },
    easeInCirc: function (x) {
      return 1 - sqrt( 1 - pow( x, 2 ) );
    },
    easeOutCirc: function (x) {
      return sqrt( 1 - pow( x - 1, 2 ) );
    },
    easeInOutCirc: function (x) {
      return x < 0.5 ?
        ( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
        ( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
    },
    easeInElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        -pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
    },
    easeOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
    },
    easeInOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        -( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
        pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
    },
    easeInBack: function (x) {
      return c3 * x * x * x - c1 * x * x;
    },
    easeOutBack: function (x) {
      return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
    },
    easeInOutBack: function (x) {
      return x < 0.5 ?
        ( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
        ( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
    },
    easeInBounce: function (x) {
      return 1 - bounceOut( 1 - x );
    },
    easeOutBounce: bounceOut,
    easeInOutBounce: function (x) {
      return x < 0.5 ?
        ( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
        ( 1 + bounceOut( 2 * x - 1 ) ) / 2;
    }
  });

global._isSP = undefined;
var Init = function(){
  var $window = $(window);
  var $body = $("body").addClass("loaded").animate({opacity: 1}, 500);
  var $header = $("header").delay(0).animate({opacity: 1}, 300);
  var $footer = $("footer");

  var NavColorChange = function(){
    if($window.scrollTop() > $header.outerHeight()){
      if(!$header.hasClass("header--scrolled")){
        $header.addClass("header--scrolled");
      }
    }else{
      if($header.hasClass("header--scrolled")){
        $header.removeClass("header--scrolled");
      }
    }
  };
  $window.on("scroll", NavColorChange);
  NavColorChange();

  var $nav = $("nav.nav");

  var _navContentdelayTime = 50;
  $nav.find(".wait").each(function(i){
    var _$this = $(this);
    _$this.attr("data-delay", i * _navContentdelayTime);
  });

  var $navButton = $(".header-nav--btn, .nav--close");
  var NavOpenClose = function(){
    if($body.hasClass("nav--open")){
      $body.removeClass("is-modal");
      $nav.stop().animate({opacity: 0}, 300, function(){
        $body.removeClass("nav--open");
        $nav.css({opacity: ""});
        ResetAnimate($nav);

      });
    }else{
      $body.addClass("nav--open");
      $body.addClass("is-modal");
      AnimationStart($nav);
    }
  };

  window.GoTopShopContent = function(){
    $("html, body").stop().animate({opacity: 1, scrollTop: $("#shop").offset().top}, 500, "easeInOutCirc");
    return false;
  };

  $(".top-shop").on("click", function(){
    if($body.hasClass("nav--open")){
      NavOpenClose();
    }
    GoTopShopContent();
    return false;
  });

  $navButton.on("click", NavOpenClose);

  // ScrollAnimatiopn
  window.AnimationStart = function($container){
    // console.log("AnimationStart");
    var _$wait = $container.find(".wait");
    _$wait.each(function(){
      var __$this = $(this);
      var __delay = __$this.data("delay");
      var __timeout = setTimeout(function(){
        __$this
          .removeClass("wait")
          .addClass("animation");
        clearTimeout(__timeout);
      }, __delay)
    });
  };

  window.ResetAnimate = function($container){
    // console.log("ResetAnimate");
    var _$animate = $container.find(".animation");
    var _$animating = $container.find(".animating");
    _$animate.each(function(){
      var __$this = $(this);
      __$this
        .addClass("wait")
        .removeClass("animation");
    });
    _$animating.each(function(){
      var __$this = $(this);
      __$this
        .addClass("waiting")
        .removeClass("animating");
    });

  };

  var setAnimation = function(){
    // console.log("setAnimation:");
    // console.log("scrollTop: " + $(scrollTarget).scrollTop());
    var $section = $(".waiting");
    var sectionLen = $section.length;
    var timing, _height, mainHeight, mainTop;
    _height = $window.height();
    mainTop = 0;
    timing = _height - (_height / 2);

    for(var i = 0; i < sectionLen; i++){
      var $wait = $($section[i]);
      var offsetTop;

      offsetTop = $wait.offset().top;
      var _delay = $wait.data("delay");
      if(_delay === void 0){
        _delay = 0;
      }
      $wait.delay(_delay).queue(function(){
        var __$this = $(this);
        __$this.removeClass("waiting").addClass('animating');
        __$this.dequeue();
      });
    }
  };

  var AnimationScroller = function(){
    setAnimation();
    if($body.css("opacity") !== "1"){
      $body.stop().animate({opacity: 1}, 100);
    }
  };

  $window.on("scroll", AnimationScroller);
  AnimationScroller();

  $(".pagetop").on("click", function(){
    $("html, body").stop().animate({scrollTop: 0}, 1000, "easeInOutCirc");
  });

  var Resize = function(){
    if($window.width() < 751){
      _isSP = true;
    }else{
      _isSP = false;
    }
  };
  $window.on("resize", Resize);
  Resize();


  /*
   * 記事コンテンツ
   * .mt-be-columns 処理
   */
  var $columns = $(".mt-be-columns");
  if($columns.length > 0){
    $columns.each(function(){
      var _$this = $(this);
      var _$column = _$this.find(".mt-be-column");
      if(_$column.length === 3){
        _$this.addClass("mt-be-columns3");
      }else if(_$column.length === 4){
        _$this.addClass("mt-be-columns4");
      }
    });
  }

  /*
   * 記事コンテンツ
   * 埋め込み動画/MAP iframe 処理
   */
  $(".article iframe").each(function(){
    var _$this = $(this);
    _$this.wrap("<div class='embed'></div>");
  });

  /*
   * 記事コンテンツ
   * aタグ href が画像パスの場合モーダルが開くようにする
   */
  var $articleA = $(".article a");
  if($articleA.length > 0){
    var $modal = $("#article_modal");
    var $modalClose = $("#article_modal_close");
    var $modalContent = $("#article_modal_content");
    var $modalOverlay = $("#article_modal_overlay");
    var _modalImage;

    var SetModalImage = function(){
      console.log("SetModalImage");
      $modalContent.append(_modalImage);
      $modal.css({display: "block"}).stop().animate({opacity: 1}, 300);
      $body.addClass("is-modal");

      _modalImage.removeEventListener("load", SetModalImage);
    };

    var ModalOpen = function(event){
      console.log("ModalOpen");
      var _src = $(event.currentTarget).find("img")[0].src;

      _modalImage = new Image();
      _modalImage.addEventListener("load", SetModalImage);
      _modalImage.src = _src;

      return false;
    };
    var ModalClose = function(event){
      $modalContent.empty();
      if($body.hasClass("is-modal")){
        $modal.stop().animate({opacity: 0}, 300, function(){
          $modal.css({display: "", opacity: ""});
          $body.removeClass("is-modal");
        });
      }else{
      }
    };

    $modalClose.on("click", ModalClose);
    $modalOverlay.on("click", ModalClose);

    $articleA.each(function(){
      var _$this = $(this);
      var _href = _$this.attr("href");
      if(_href.match(/.+(jpg|jpeg|gif|png)/) !== null){
        _$this.on("click", ModalOpen);
      }
    });
  }

  /*
   * 地図モーダル
   */
  var $map = $(".map");
  var $shopBtn = $(".shop--btn a");
  if($map.length > 0 && $shopBtn.length > 0){
    var $mapCloseIcon = $(".map--close");
    var OpenMapContent = function(){
      if($body.hasClass("is-modal")){
        CloseMapContent();
      }else{
        $map.addClass("map--open").stop().animate({opacity: 1}, 300);
        $body.addClass("is-modal");
      }
      return false;
    };
    var CloseMapContent = function(){
      $map.stop().animate({opacity: 0}, 300, function(){
        $map.removeClass("map--open").css({opacity: ""});
        $body.removeClass("is-modal");
      });
    };
    $shopBtn.on("click", OpenMapContent);
    $mapCloseIcon.on("click", CloseMapContent);

    var $mapContents = $(".map-content-area");
    var $mapTabs = $(".map--tab");
    var ChangeMap = function(event){
      var _$this = $(this);
      var _type = _$this.data("type");

      $mapContents.each(function(i){
        var _$content = $(this);
        var _contentType = _$content.data("type");

        if(_contentType === _type){
          _$content.addClass("map--current");
        }else{
          _$content.removeClass("map--current");
        }
      });

      $mapTabs.each(function(i){
        var _$tab = $(this);
        var _tabType = _$tab.data("type");

        if(_tabType === _type){
          _$tab.addClass("map--current");
        }else{
          _$tab.removeClass("map--current");
        }
      });
    };
    $mapTabs.on("click", ChangeMap);
  }

  /**
   *
   * @param event
   * @returns {boolean}
   * @constructor
   */
  var Fadeout = function(event){
    var _$target = $(this);
    var _href = _$target.attr("href");
    if(
      _href.indexOf(".gif") < 0 &&
      _href.indexOf(".png") < 0 &&
      _href.indexOf(".jpg") < 0 &&
      _href.indexOf(".jpeg") < 0
    ){
      if(_href !== "" && _href.indexOf("#") < 0){
        if(_$target.attr("target") !== "_blank"){
          $body.animate({opacity: 0}, 500, function(){
            $body.removeClass("nav--open").removeClass("is-modal")
            window.location.href = _href;
            $body.delay(1000).animate({opacity: 1});
          });
          return false;
        }
      }
    }
  };
  $("a").on("click", Fadeout);

};

window.addEventListener("load", Init);